<template>
	<div class="containerMain">
		<title-bar :topTitle="true" topTitleText="Evaluación" class="mb-4"/>
		<title-bar v-if="school" :title="school.name" class="mb-4"/>
		<div class="col inner" v-if="evaluation" >
			<div style="width: 100%;">

				<div class="mb-4">
					<p>{{`Visita ${evaluation.visit.visit} del ${getHumanDateAndTime(evaluation.answeredAt)}`}}</p>
				</div>

				<div class="mb-4">
					<h2>Profesor</h2>
					<p>{{getPersonFullName(teacher)}}</p>
				</div>

				<template v-if="evaluation.status.code == 'NULL'">
					<p>Esta evaluación fue anulada.</p>
					<b-form-textarea class="text-justify" style="background-color: white;" :rows="3" type="text" name="observations" v-model="evaluation.observations" :disabled="true"/>
				</template>

				<template v-else>
					<div class="mb-4">
						<h2>Comentario </h2>
						<b-form-textarea v-if="evaluation.observations" class="text-justify" style="background-color: white;" :rows="3" type="text" name="observations" v-model="evaluation.observations" :disabled="true"/>
						<p v-else>
							Sin registro
						</p>
					</div>

					<div class="mb-4">
						<h2>Áreas de mejora </h2>
						<table class="table table-sm table-striped" v-if="evaluation.feedback[0]">
							<tr v-for="(item, index) in evaluation.feedback" v-if="item" :key="`feedback${index}`">
								<td><p class="text-justify">{{item}}</p></td>
							</tr>
						</table>
						<p v-else>
							Sin registro
						</p>
					</div>

					<div class="mb-4">
						<h2>Fortalezas </h2>
						<table class="table table-sm table-striped" v-if="evaluation.strengths[0]">
							<tr v-for="(item, index) in evaluation.strengths" v-if="item" :key="`strengths${index}`">
								<td><p class="text-justify">{{item}}</p></td>
							</tr>
						</table>
						<p v-else>
							Sin registro
						</p>
					</div>

					<div class="mb-4 small-content">
						<div class="category" v-for="(category, index) in answers" :key="`category-${index}`">
							<h2>{{evaluation.language.isoCode == 'es' ? category.categoryEs : category.categoryEn}}</h2>
							<table class="table table-sm table-striped">
								<template v-for="question in category.questions" >
									<tr :key="`question-${question.questionEs}`">
										<td>{{evaluation.language.isoCode == 'es' ? question.questionEs : question.questionEn}}</td>
										<td><strong>{{question.value || 0}}</strong></td>
									</tr>
									<tr v-if="question.observations" :key="`question-${question.questionEn}`">
										<td colspan="2">
											<b-card no-body class="pt-2 pr-2 pl-2 pb-2" style="width: 100%;">
												<p class="text-justify">{{question.observations}}</p>
											</b-card>
										</td>
									</tr>
								</template>
							</table>
						</div>
					</div>
				</template>

			</div>
		</div>
		<div class="col inner" v-else>
			<spinner :isMiniSpinner="true"/>
		</div>
	</div>
</template>

<script>
import helpers from '@/helpers';
import mediator from '@/mediator';

export default {
	props: ['evaluationId', 'schoolId'],
	mounted () {
		setTimeout(() => {
			mediator.showContent();
		}, 1000);
	},
	computed: {
		evaluation () {
			let evaluation = this.$store.state.admin.evaluation.evaluation;
			let type = typeof evaluation.feedback;
			if (type !== 'object') evaluation.feedback = JSON.parse(evaluation.feedback);
			type = typeof evaluation.strengths;
			if (type !== 'object') evaluation.strengths = JSON.parse(evaluation.strengths);
			return evaluation;
		},
		answers () {
			return this.$store.state.admin.evaluation.answers;
		},
		teacher () {
			return this.$store.state.admin.evaluation.person;
		},
		school () {
			if (!this.$store.state.admin.schools) return null;
			if (!this.schoolId) return null;
			return this.$store.state.admin.schools.find((school) => (school.schoolId == this.schoolId));
		}
	},
	methods: {
		getHumanDateAndTime (date) {
			return helpers.dateTime.getHumanDateAndTime(date);
		},
		getPersonFullName (person) {
			return helpers.persons.getPersonFullName(person);
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/routes/admin/EvaluationDetail.vue